<template>
  <div>
    <list-vue
      v-bind:busqueda="busqueda"
      v-bind:busquedaTraduccion="busquedaTraduccion"
      v-bind:busquedaMedidas="busquedaMedidas"
      v-bind:opciones="opciones"
      v-bind:moduloTitulo="moduloTitulo"
      v-bind:pantallaTitulo="pantallaTitulo"
      v-bind:rutaConsulta="rutaConsulta"
      v-bind:buttonsPage="buttonsPage"
      v-bind:busquedaCampos="busquedaCampos"
    ></list-vue>
  </div>
</template>
  <script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      //Definimos los nombres generales
      moduloTitulo: this.$root.trans("Tabla de Tipos de Registro"),
      reporte: false,
      pantallaTitulo: this.$root.trans("Resultado"),
      rutaConsulta: this.$route.fullPath,
      buttonsPage: [
        {
          type: "button",
          class: "btn btn-xs btn-info pull-right",
          route: "AuthorsCreate",
          text: '<i class="fa fa-plus">',
          external: "../../../../../editatiponc.php?filtroTipoNC=RE",
        },
      ],
      //Definimos los campos de busqueda, sus nombres e incluso tamaño
      busqueda: {
        codigo: "",
        descripcion: "",
        categoria_nc: "",
        nodo_numer: "",
        marca_clien_prove: "",
        estado: "",
      },
      busquedaTraduccion: {
        codigo: this.$root.trans("Codigo"),
        descripcion: this.$root.trans("Descripción"),
        categoria_nc: this.$root.trans("Categoria"),
        nodo_numer: this.$root.trans("Nodo Numer."),
        marca_clien_prove: this.$root.trans("Sujeto"),
        estado: this.$root.trans("Estado"),
      },
      busquedaCampos: {
        estado: {
          type: "select",
          options: [
            { label: "Activo", code: "A" },
            { label: "Desactivado", code: "B" },
          ],
        },
        marca_clien_prove: {
          type: "select",
          options: [
            { label: "Ninguno", code: "null" },
            { label: "Cliente", code: "C" },
            { label: "Proveedor", code: "P" },
            { label: "Personal", code: "E" },
          ],
        },
      },
      busquedaMedidas: {
        codigo: "90px",
        descripcion: "",
        categoria_nc: "120px",
        nodo_numer: "140px",
        marca_clien_prove: "180px",
        estado: "170px",
      },
      //definimos las opciones con enlace simple para ello usamos el nombre de la ruta y en caso de eliminar usamos la ruta
      opciones: [
        // {
        //     class:'btn btn-sm btn-warning',
        //     icon:'fas fa-edit',
        //     routerName:'TiposRegistroEdit',
        //     param:'codigo',
        //     eliminar:false,
        //     nombre:'Editar'
        // },
        // {
        //     class:'btn btn-sm btn-danger',
        //     icon:'fa fa-trash-alt',
        //     routerName:'/backend/authors/delete/',
        //     param:'id',
        //     eliminar:true,
        //     nombre:'Eliminar'
        // }
      ],
    };
  },
  computed: {
    ...mapState(["request"]),
  },
  methods: {
    ...mapMutations({ requestSet: "request" }),
  },
  mounted() {
    this.requestSet(this.$route.query);

    if (typeof this.$store.state.request.categoriaNC !== "undefined") {
      this.reporte = this.$store.state.request.categoriaNC;
    }

    // if (this.reporte === "NO") {
    // } else {
    //   delete this.busqueda["fica___valor_version"];
    //   delete this.busquedaTraduccion["fica___valor_version"];
    //   delete this.busquedaMedidas["fica___valor_version"];

    //   this.$delete(this.busqueda, "fica___valor_version");
    //   this.$delete(this.busqueda, 1);
    //   this.busqueda["sujeto"] = "";
    //   this.busquedaTraduccion["sujeto"] = this.$root.trans("Sujeto");
    //   this.busquedaMedidas["sujeto"] = "90px";

    //   this.busqueda["proceso_descripcion"] = "";
    //   this.busquedaTraduccion["proceso_descripcion"] =
    //     this.$root.trans("Proceso");
    //   this.busquedaMedidas["proceso_descripcion"] = "90px";

    //   this.busqueda["clasificacion"] = "";
    //   this.busquedaTraduccion["clasificacion"] = this.$root.trans("Clasific.");
    //   this.busquedaMedidas["clasificacion"] = "90px";
    // }
  },
  created() {
    this.requestSet(this.$route.query);
  },
};
</script>
